// ActTags.jsx
import React, { useRef, useState, useEffect } from 'react';

import { doc, collection, getDocs, deleteDoc, updateDoc, deleteField, writeBatch, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

import { saveUserLog } from './LogandUtils';

import styleClasses from './css/MyPage.module.scss';
import styleClasses2 from './css/mobile/MyPage.module.scss'

const ActTags = ({ act, userUid, attribute, albumID, setSelectedItem, fetchData, setOpenPopup, setButtonLoading, setPopupTitle, setPopupFunction, setPopupButtonText, mobile, openPushPopup }) => {
  const tagKeys = Object.keys(act || {});
  const isSubmitting = useRef(false);
  
  // cardslot 값: /users/[userUid] 문서의 cardslot 필드를 가져옴
  const [cardSlot, setCardSlot]     = useState(null);

  // ⛳ 삭제할 하위 컬렉션 목록
  const subcollections = ['tracks', 'skills']; // 필요에 따라 추가

  useEffect(() => {
    if (userUid) {
      const fetchCardSlot = async () => {
        try {
          const userDocRef = doc(db, "users", userUid);
          const userSnap = await getDoc(userDocRef);
          if (userSnap.exists()) {
            const data = userSnap.data();
            setCardSlot(data.cardslot || 0);
          } else {
            setCardSlot(0);
          }
        } catch (error) {
          console.error("Error fetching cardSlot:", error);
          setCardSlot(0);
        }
      };
      fetchCardSlot();
    }
  }, [userUid]);

  const openDeletePopup = (tag) => {
    setOpenPopup(true);
    setPopupTitle(`뮤지카드 ${tag}에서 해당 항목을 삭제하시겠습니까?`);
    setPopupButtonText('삭제');
    setPopupFunction(() => () => handleDelete(tag));
  };

  const handleDelete = async (tag) => {
    try {
      if (isSubmitting.current) return; // 중복 클릭 방지
      isSubmitting.current = true;
      setButtonLoading(true);

      // 조건에 따라 다르게 처리
      let realAttribute;
      let docName;

      if (attribute === 'released' || attribute === 'unreleased') {
        realAttribute = act[tag];
        docName = albumID;
      } else if (attribute === 'positions') {
        realAttribute = attribute;
        docName = act[tag];
      } else if (attribute === 'activity') {
        realAttribute = act[tag]; // ✅ 여기가 명확히 수정됨!
        docName = albumID;
      } else {
        realAttribute = attribute;
        docName = albumID;
      }

      console.log(`🔍 Deleting from musicians/${tag}/${attribute}/${docName}`);

      // 1. musicians/{뮤지카드ID}/{attribute}/{문서ID} 삭제
      const basePath = `musicians/${tag}/${realAttribute}/${docName}`;
      const musicianDocRef = doc(db, basePath);

      // 2. 해당 문서의 하위 컬렉션 (예: tracks) 삭제
      for (const subCol of subcollections) {
        const subColRef = collection(db, `${basePath}/${subCol}`);
        const subSnapshot = await getDocs(subColRef);
        if (!subSnapshot.empty) {
          const batch = writeBatch(db);
          subSnapshot.forEach((docSnap) => batch.delete(docSnap.ref));
          await batch.commit();
          console.log(`🧹 Deleted subcollection '${subCol}'`);
        }
      }

      // 3. 해당 문서 삭제
      await deleteDoc(musicianDocRef);
      console.log(`✅ Document deleted: ${musicianDocRef.path}`);

      // 4. users_data/{uid}/{attribute}/{문서ID}의 act 필드 업데이트
      const userDocRef = doc(db, 'users_data', userUid, attribute, docName);
      await updateDoc(userDocRef, {
        [`act.${tag}`]: deleteField()
      });
      
      const changedPaths = [musicianDocRef.path];
      await saveUserLog('musicard_logs', tag, 'delete', changedPaths, 'ActTags');

      isSubmitting.current = false;
      setButtonLoading(false);

      setOpenPopup(true);
      setPopupTitle(`항목이 뮤지카드 ${tag}에서 삭제되었습니다.`);
      setPopupButtonText('');
      setPopupFunction('');

      fetchData();
    } catch (error) {
      isSubmitting.current = false;
      setButtonLoading(false);

      setOpenPopup(true);
      setPopupTitle(`삭제 중 오류가 발생했습니다.`);
      setPopupButtonText('');
      setPopupFunction('');

      console.error("삭제 오류:", error);
    }
  };

  return (
    <div className={ !mobile ? styleClasses.albumTags : styleClasses2.albumTags }>
      {tagKeys.length > 0 && tagKeys.map((tag) => (
        <button key={tag} className={ !mobile ? styleClasses.tagButton : styleClasses2.tagButton } onClick={() => openDeletePopup(tag)}>
          { tag }
        </button>
      ))}
      {(tagKeys.length === 0 || (cardSlot !== null && tagKeys.length < cardSlot)) && (
        <button
          onClick={() => {
            if (typeof openPushPopup === 'function') {
              // 부모가 팝업열기 함수를 넘겼다면 팝업을 즉시 열어줌
              openPushPopup(albumID);
              console.log(1);
            } else {
              // 기존 방식 그대로 유지 (ArchiveList 등)
              setSelectedItem([albumID]);
              console.log(2);
            }
          }}
          className={`commonIcon ${!mobile ? styleClasses.tagButton : styleClasses2.tagButton} ${mobile ? 'mobile' : undefined}`}
        >
          <i className='plusWhite'></i>
        </button>
      )}
    </div>
  );
};

export default ActTags;